import { AxiosRequestConfig } from 'axios'

export interface GoogleConnectionStatus {
  connected: boolean
  connectedEmail?: string
  connectedAt?: string
  lastSyncAt?: string
  lastSyncError?: string | null
  syncInProgress?: boolean
  syncStartedAt?: string | null
}

export interface GoogleSyncResult {
  started: boolean
  message: string
}

export interface GoogleStatusResponse {
  google: GoogleConnectionStatus
}

export interface GoogleSyncResponse {
  result: GoogleSyncResult
}

const getGoogleStatus = (): AxiosRequestConfig => ({
  method: 'GET',
  url: '/reviews/google/status',
})

const getGoogleAuthUrl = (): AxiosRequestConfig => ({
  method: 'GET',
  url: '/reviews/google/auth-url',
})

const disconnectGoogle = (): AxiosRequestConfig => ({
  method: 'POST',
  url: '/reviews/google/disconnect',
})

const syncGoogleReviews = (storeId?: number): AxiosRequestConfig => ({
  method: 'POST',
  url: '/reviews/google/sync',
  data: storeId ? { storeId } : {},
})

const replyToGoogleReview = (reviewId: number, comment: string): AxiosRequestConfig => ({
  method: 'POST',
  url: `/reviews/${reviewId}/google/reply`,
  data: { comment },
})

export {
  getGoogleStatus,
  getGoogleAuthUrl,
  disconnectGoogle,
  syncGoogleReviews,
  replyToGoogleReview,
}
